/** The API answers 410 RECORDING_EXPIRED once the retention job has removed a recording (D-CALLS-10). */
export const isRecordingDeleted = (error: unknown): boolean =>
    typeof error === 'object' && error !== null && (error as {status?: unknown}).status === 410;

/** Same wording as the API's RECORDING_EXPIRED message. */
export const RECORDING_DELETED_BODY = 'This recording was deleted in line with the configured retention period.';
